import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { REQUIRES_AUTH } from './auth-context';

/**
 * Intercepteur d'authentification qui ajoute automatiquement le header Authorization
 * aux requêtes marquées comme nécessitant une authentification
 */
export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const requiresAuth = req.context.get(REQUIRES_AUTH);
  
  if (requiresAuth) {
    const token = localStorage.getItem('auth_token');
    
    if (token) {
      const clonedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next(clonedReq);
    }
  }
  
  return next(req);
};
